import React, { Component } from 'react';
import { presets, spring, TransitionMotion } from 'react-motion';

import { WrapperSize } from '../../contrib/ui';

interface ICard {
  height?: number;
  name: string;
  children: JSX.Element;
}

interface ICardsProps {
  children: Array<React.ReactElement<ICard> | Array<React.ReactElement<ICard>>>;
  // eager loading means it will keep all the cards rendered, and display only the selected one
  // false by default it will keep only the selected card and, mount/render the new ones as needed
  eager?: boolean;
  selected: number;
}

class FancyCards extends Component<ICardsProps> {
  public getDefaultStyles = () => {
    const { selected, children } = this.props;

    const cardStyles = React.Children.toArray(children)
      .map((child: any) => ({
        data: child,
        key: `card-${child.props.name}`,
        style: { left: 0, opacity: 1, position: 1, height: 0 }
      }))
      .filter((_: any, index: number) => index === selected);
    const mainStyles = {
      data: {},
      key: 'container',
      style: {
        height: 0
      }
    };

    return [mainStyles].concat(cardStyles as any);
  };

  public getStyles = () => {
    const { selected, children, eager } = this.props;

    let cardStyles = React.Children.toArray(children).map((card: any, index) => {
      return {
        data: card,
        key: `card-${card.props.name}`,
        style: {
          height: card.props.height,
          left: index === selected ? spring(0, presets.stiff) : spring(-WrapperSize),
          opacity: index === selected ? spring(1, presets.gentle) : spring(0),
          position: index === selected ? 1 : 0
        }
      };
    });
    if (!eager) {
      cardStyles = cardStyles.filter((_: any, index: number) => index === selected);
    }

    const mainStyles = {
      data: {},
      key: 'container',
      style: {
        height: spring(cardStyles[0].style.height || 0, presets.noWobble)
      }
    };

    return [mainStyles].concat(cardStyles);
  };

  public willEnter(): any {
    return {
      left: WrapperSize,
      opacity: 1,
      position: 1
    };
  }

  public willLeave(): any {
    return {
      left: spring(-WrapperSize),
      opacity: spring(0),
      position: 0
    };
  }

  public render(): JSX.Element {
    const { selected, eager } = this.props;
    return (
      <div className="fancy-cards">
        <TransitionMotion
          defaultStyles={this.getDefaultStyles()}
          styles={this.getStyles()}
          willLeave={this.willLeave}
          willEnter={this.willEnter}
        >
          {styles => {
            const [container, ...cards] = styles;
            const height = eager ? cards[selected].style.height : container.style.height;

            return (
              <div className="fancy-wrapper" style={{ height: height && 'auto' }}>
                {!!cards ? (
                  cards.map(({ style, data }, key) => (
                    <div
                      className="fancy-card"
                      key={key}
                      style={{
                        opacity: style.opacity,
                        position: style.position === 1 ? 'relative' : 'absolute',
                        right: -style.left
                      }}
                    >
                      {data.props.children}
                    </div>
                  ))
                ) : (
                  <div />
                )}
              </div>
            );
          }}
        </TransitionMotion>
      </div>
    );
  }
}

const Card = ({ children }: ICard) => {
  return <div>{children}</div>;
};

export { FancyCards, Card };
